import { defineStore } from 'pinia';
import { PortalInfo } from '../helper/PortalHelper';

export const usePortalStore = defineStore('portal', {
  state: () => ({
    portalInfo: null as PortalInfo | null
  }),
  actions: {
    setPortalInfo(info: PortalInfo) {
      this.portalInfo = info;
    }
  }
});